import React from 'react'
import styled from 'styled-components'
import Button from '../../../../../components/buttons/buttons.component'
import DatepickerInput from '../../../../../components/form-components/datepicker-input.component.jsx'
import StyledFlexContainer from '../../../../../components/containers/flex-container.component.jsx'
import * as Yup from 'yup'
import {
	NumberInput,
	SelectInput,
	TextInput,
	CouponInput,
	DateInput,
} from '../../../../../components/form-components/inputs.component'
import { routes } from '../../../../../constants/routes.constants'
import { Form, Formik } from 'formik'
import { couponConstants } from './../../../../../constants/coupon-type.constants'
import { PRIMARY_LIGHT } from '../../../../../styles/colors.style'
import { breakpoints } from './../../../../../constants/breakpoits.constants'

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 2.7rem;
`

const schema = Yup.object().shape({
	code: Yup.string().required('Informe o código do cupom'),
	description: Yup.string().required('Informe a descrição do cupom'),
	discountPercentage: Yup.number().required(
		'Informe a percentagem de desconto'
	),
	couponsAmount: Yup.number().moreThan(
		0,
		'A quantidade de cupons não pode ser 0'
	),
	couponsPerCustomer: Yup.number().required(
		'Informe a quantidade de resgates por cliente'
	),
	dateStart: Yup.date().required('Informe a data de início'),
	dateEnd: Yup.date().required('Informe a data de término'),
})

const initialValues = {
	code: '',
	active: '',
	dateEnd: '',
	dateStart: '',
	busCompany: '',
	couponType: '',
	description: '',
	couponsAmount: '',
	moveflexNumber: '',
	couponsPerCustomer: '',
	discountPercentage: '',
	boardingDate: '',
	boardingDateEnd: '',
	validForRoundTrip: '',
	busClasses: '',
	paymentMethod: '',
	daysInAdvanceForBoarding: '',
	origins: '',
	destinations: '',
}

class DetailsForm extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			dateStart: '',
			dateEnd: '',
			disablePartner: false,
			boardingDate: null,
			boardingDateEnd: null,
		}
	}

	changeAction = (props, state) => {
		this.setState({ disablePartner: state })
	}

	setValues(values) {
		const { dateStart, dateEnd, boardingDate, boardingDateEnd } = values
		this.setState({
			dateEnd: new Date(dateEnd),
			dateStart: new Date(dateStart),
			boardingDate: boardingDate != null ? new Date(boardingDate) : null,
			boardingDateEnd:
				boardingDateEnd != null ? new Date(boardingDateEnd) : null,
		})

		for (const key of Object.keys(values)) {
			if (key == 'couponType') {
				const { value } = couponConstants.couponTypeOptions.find(
					({ label }) => label == values.couponType
				)
				this.refs.form.setFieldValue(key, value)
			} else if (key == 'busCompany') {
				const selectedOption = couponConstants.couponBusCompanyOptions.find(
					({ value }) => value === values.busCompany
				)

				if (selectedOption) {
					const { value } = selectedOption
					this.refs.form.setFieldValue(key, value)
				}
			} else if (key == 'paymentMethod') {
				const selectedOption =
					couponConstants.couponPaymentMethodOptions.find(
						({ value }) => value === String(values.paymentMethod)
					)

				if (selectedOption) {
					const { value } = selectedOption
					this.refs.form.setFieldValue(key, value)
				}
			} else {
				this.refs.form.setFieldValue(key, '' + values[key])
			}
		}
	}

	render() {
		const { onSubmit } = this.props
		const { dateStart, dateEnd, boardingDate, boardingDateEnd } = this.state
		return (
			<div>
				<Formik
					ref={'form'}
					initialValues={initialValues}
					onSubmit={onSubmit}
					validationSchema={schema}
					render={(props) => (
						<Form className="form" noValidate>
							<StyledFlexContainer>
								<CouponInput
									className={'col-4'}
									id="code"
									label="Código do Cupom *"
									maxLength={16}
									autoFocus={true}
									{...props}
								/>
								<TextInput
									className={'col-6'}
									id="description"
									label="Descrição *"
									maxLength={256}
									{...props}
								/>
								<SelectInput
									className={'col-2'}
									id="active"
									label="Situação"
									defaultValue={{ value: '', label: '' }}
									options={statusOptions}
									multi={false}
									disabled
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<NumberInput
									className={'col-3'}
									id="discountPercentage"
									label="% de desconto *"
									maxLength={2}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="couponsAmount"
									label="Quantidade de cupons"
									maxLength={16}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="couponsPerCustomer"
									label="Cupons por usuário *"
									maxLength={6}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="redeemedCoupons"
									label="Cupons resgatados"
									maxLength={16}
									disabled
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<StyledDocument className="col-3">
									<TextInput
										id="dateStart"
										label="Data de Início"
										type={'date'}
										{...props}
									/>
								</StyledDocument>
								<StyledDocument className="col-3">
									<TextInput
										id="dateEnd"
										label="Data de Término *"
										type={'date'}
										{...props}
									/>
								</StyledDocument>
								<SelectInput
									disabled
									{...props}
									label="Tipo"
									multi={false}
									id="couponType"
									className={'col-3'}
									onValueChange={(value) => {
										value === 'pointsPurchase'
											? this.changeAction(props, true)
											: this.changeAction(props, false)
									}}
									options={couponConstants.couponTypeOptions}
								/>
								<SelectInput
									{...props}
									disabled={this.state.disablePartner}
									multi={false}
									label="Parceiro *"
									id="busCompany"
									className={'col-3'}
									options={couponConstants.couponBusCompanyOptions}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<SelectInput
									className={'col-3'}
									id="validForRoundTrip"
									label="Válido para ida e volta"
									defaultValue={{ value: '', label: '' }}
									options={tripOptions}
									multi={false}
									{...props}
								/>
								<DatepickerInput
									showClearDate
									openDirection={'up'}
									className={'col-3'}
									id="boardingDate"
									label="Data de Embarque - Início"
									date={boardingDate}
									{...props}
								/>
								<DatepickerInput
									showClearDate
									openDirection={'up'}
									className={'col-3'}
									id="boardingDateEnd"
									label="Data de Embarque - Fim"
									date={boardingDateEnd}
									{...props}
								/>
								<NumberInput
									className={'col-3'}
									id="moveflexNumber"
									label="Cliente (Número Moveflex)"
									maxLength={16}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-6'}
									id="busClasses"
									label="Modalidades"
									placeholder={
										'Insira as modalidades permitidas, separadas por vírgula. Deixe em branco para não aplicar a validação.'
									}
									maxLength={256}
									{...props}
								/>
								<SelectInput
									{...props}
									multi={false}
									label="Método de pagamento  *"
									id="paymentMethod"
									className={'col-3'}
									options={couponConstants.couponPaymentMethodOptions}
								/>
								<NumberInput
									className={'col-3'}
									id="daysInAdvanceForBoarding"
									label="Dias de Antecedência"
									maxLength={2}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-12'}
									id="origins"
									label="Origem"
									maxLength={600}
									placeholder={
										'Insira as cidades permitidas, separadas por vírgula. Deixe em branco para não aplicar a validação.'
									}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledFlexContainer>
								<TextInput
									className={'col-12'}
									id="destinations"
									label="Destino"
									maxLength={600}
									placeholder={
										'Insira as cidades permitidas, separadas por vírgula. Deixe em branco para não aplicar a validação.'
									}
									{...props}
								/>
							</StyledFlexContainer>
							<StyledButtonContainer>
								<Button
									onClick={() =>
										this.props.history.push(
											`${routes.ADMIN}/cupons-de-desconto`
										)
									}
									danger
									style={{ marginRight: '15px' }}
									type="button">
									Cancelar
								</Button>
								<Button
									data-permission="BF776B706A71CF03396AE7D3EA5E953DC5EC8350"
									primary
									type="submit">
									Salvar
								</Button>
							</StyledButtonContainer>
						</Form>
					)}
				/>
			</div>
		)
	}
}

const statusOptions = [
	{ value: '', label: '' },
	{ value: 'true', label: 'Ativo' },
	{ value: 'false', label: 'Inativo' },
]

const tripOptions = [
	{ value: '', label: '' },
	{ value: 'true', label: 'Sim' },
	{ value: 'false', label: 'Não' },
]

const StyledDocument = styled.div`
	.is-client {
		color: ${PRIMARY_LIGHT};
		margin-top: 10px;
		position: absolute;
	}
	@media screen and (max-width: ${breakpoints.IPHONE_SE}px) {
		.is-client {
			margin-top: 3px;
		}
	}
`

export default DetailsForm
